import React, { memo } from 'react';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import CustomLink from '../CustomLink/CustomLink';
import Heading, { HeadingTypes } from '../Heading/Heading';
import SbImage from '../SbImage/SbImage';

interface PartnersBlokCardProps {
  url: string;
  image: StoryblokAsset;
  title: string;
  body: string;
}

const PartnersBlokCard: React.FC<PartnersBlokCardProps> = ({
  url,
  image,
  title,
  body,
}) => {
  return (
    <CustomLink url={url} label={title} className="block group space-y-8">
      {image && (
        <div className="w-full aspect-video">
          <SbImage
            asset={image}
            options={{
              width: 600,
              height: 400,
              sizes: { base: 1200 },
              objectFit: 'cover',
            }}
          />
        </div>
      )}
      <div className="space-y-4">
        <Heading text={title} headingType={HeadingTypes.h4} />
        <p className="text-text/body text-base font-normal">{body}</p>
      </div>
    </CustomLink>
  );
};

export default memo(PartnersBlokCard);
